<script setup>
import {ref, watch} from 'vue';
import dayjs from "dayjs";
import countdown from '@/StandaloneJS/vue-countdown';

const props = defineProps({
  timedue: Date
});

const timeDueVal = ref(props.timedue);

watch(()=>props.timedue,(newVal)=>{
  timeDueVal.value = newVal;
})

const isPastDue = (timeDueVal) => {
  const dtTimedue = dayjs(timeDueVal)
  return dtTimedue.isBefore(new Date())
}

const timeDiff = (otherTime) => {
  let dtOtherTime = dayjs(otherTime)
  let now = new Date()
  return dtOtherTime.isBefore(now) ? now - dtOtherTime : dtOtherTime - now
}

</script>

<template>
  <v-chip :key="timedue" :color="isPastDue(timedue) ? 'red' : 'green'" label text-color="white">
    <v-icon left>mdi-calendar</v-icon>
    <countdown :time="timeDiff(timedue)"
               :interval="isPastDue(timedue) ? -1000 : 1000" v-on:end="$forceUpdate()">
      <template v-slot="props">
        {{props.totalHours.toString().padStart(2,0) }}:{{
          props.minutes.toString().padStart(2,0) }}:{{
          props.seconds.toString().padStart(2,0) }}
      </template>
    </countdown>
  </v-chip>
</template>

<style scoped>

</style>